module.exports = __webpack_public_path__ + "img/1440.2258e22f.jpg";